import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Venta } from "@/shared/types/venta";

export async function getVenta(id: string): Promise<Venta> {
    await sleep(1000);
    const response = await api.get("ventas/" + id);
    return response.data;
}

export function useGetVentaQuery(id: string, queryConfig: QueryConfig<Venta> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getVenta(id),
        queryKey: ["ventas", id],
    })
}

export interface GetVentaQueryProps {
    id: string,
    queryConfig?: QueryConfig<Venta>,
    children?: (queryResult: QueryResult<Venta>) => ReactNode
}

export function GetVentaQuery({
    id,
    children,
    queryConfig
}: GetVentaQueryProps) {
    const queryResult = useGetVentaQuery(id, queryConfig);
    return children && children(queryResult);
}